module.exports = __webpack_public_path__ + "static/media/Asarco_Mine.180aea11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/itbuildout/Asarco_Mine.jpg
// module id = 403
// module chunks = 0